export const FF_WEBPUSH = 'ff_webpush'
export const FF_DARK_LIGHT_MODE_TOGGLE = 'ff_dark_light_mode_toggle'
